import type { FC } from 'react';
import { List } from '@george-labs.com/design-system';

import type { BankMessage as BankMessageType } from '../BankMessagesTypes';
import { BankMessage } from './BankMessage';

interface Props {
    showMessageSender: boolean;
    showMessageIcon: boolean;
    messageAbsolutePath: string;
    messages: BankMessageType[];
}

export const BankMessageList: FC<Props> = ({
    showMessageSender,
    showMessageIcon,
    messageAbsolutePath,
    messages,
}) => (
    <List variant={List.VARIANT.PLAIN} className="overflow-hidden">
        {messages.map((message) => (
            <BankMessage
                key={message.id}
                showSender={showMessageSender}
                showIcon={showMessageIcon}
                messageAbsolutePath={messageAbsolutePath}
                message={message}
            />
        ))}
    </List>
);
